import { CollabsibleContainer } from "@plugins";
import noUiSlider from "nouislider";
import wNumb from "wnumb";

const filter = document.querySelector(".js-filter");

if (filter) {
    const collabsibleContaieners = filter.querySelectorAll(".js-filter-collabsible-container");

    const toggler = filter.querySelector(".js-filter-mob-toggler");
    if (toggler) {
        const filterForm = document.querySelector(".js-filter-form");

        toggler.addEventListener("click", () => {
            filterForm.classList.toggle("active");
            toggler.classList.toggle("active");
        });
    }

    for (let collabsibleContaiener of collabsibleContaieners) {
        collabsibleContaiener = new CollabsibleContainer(collabsibleContaiener, {
            buttonClasses: "filter__more js-filter-more",
            collapsibleItemsClass: "js-filter-collabsible-item",
            limiter: 5,
        });
    }
}

const sliderRange = document.querySelectorAll(".filter-range-slider");

for (let i = 0; i < sliderRange.length; i++) {
    const sliderRangeInner = sliderRange[i].closest(".filter-block");
    const marginMin = sliderRangeInner.querySelector(".min-price");
    const MinAttr = +sliderRange[i].getAttribute("data-min-price");
    const MinAttrUser = +sliderRange[i].getAttribute("data-min-price-user");
    const MaxAttr = +sliderRange[i].getAttribute("data-max-price");
    const MaxAttrUser = +sliderRange[i].getAttribute("data-max-price-user");
    const dataStep = +sliderRange[i].getAttribute("data-step");
    const marginMax = sliderRangeInner.querySelector(".max-price");

    noUiSlider.create(sliderRange[i], {
        start: [MinAttrUser, MaxAttrUser],
        behaviour: "drag",
        connect: true,
        step: dataStep,
        format: wNumb({
            decimals: 0,
        }),
        range: {
            min: MinAttr,
            max: MaxAttr,
        },
    });

    sliderRange[i].noUiSlider.on("update", (values, handle) => {
        if (handle) {
            marginMax.value = values[handle];
        } else {
            marginMin.value = values[handle];
        }
    });
    marginMin.addEventListener("change", (e) => {
        sliderRange[i].noUiSlider.set([e.target.value, null]);
    });
    marginMax.addEventListener("change", (e) => {
        sliderRange[i].noUiSlider.set([null, e.target.value]);
    });
}
